import type { DispatchedAction, DispatchedAsyncAction } from "../../../types/actions";
import {
	GetAudienceInviteStatus,
	GetPasscodeListMembers,
	SearchMembers,
	SearchMembersCount
} from "../../../connection/passcode-list-members";
import type { BrandliveEvent, EmailSubscriptions, IScheduledEmail, PasscodeListMember, SentScheduledEmailsWithEventName } from "../../../types/working-model";
import type { AudienceMemberMinimal, MergedAudienceMember } from "../../../types/audience-list-members.types";

export const GET_PASSCODE_LIST_MEMBERS = "GET_PASSCODE_LIST_MEMBERS";
type GetPasscodeListMembersAction = DispatchedAsyncAction<typeof GET_PASSCODE_LIST_MEMBERS, PasscodeListMember[] | AudienceMemberMinimal[]>;
export function getPasscodeListMembers(
	token: string,
	passcode_list: number,
	offset: number,
	order: number
): GetPasscodeListMembersAction {
	return {
		type: GET_PASSCODE_LIST_MEMBERS,
		promise: GetPasscodeListMembers(token, passcode_list, offset * 50, order)
	};
}

export const SEARCH_MEMBERS = "SEARCH_MEMBERS";
type SearchMembersAction = DispatchedAsyncAction<typeof SEARCH_MEMBERS, PasscodeListMember[] | AudienceMemberMinimal[]>;
export function searchMembers(
	token: string,
	passcode_list: number,
	offset: number,
	value: string,
	order: number
): SearchMembersAction {
	return {
		type: SEARCH_MEMBERS,
		promise: SearchMembers(token, passcode_list, offset * 50, value.toLowerCase(), order)
	};
}

export const SEARCH_MEMBER_COUNT = "SEARCH_MEMBER_COUNT";
type SearchMemberCountAction = DispatchedAsyncAction<typeof SEARCH_MEMBER_COUNT, {
	passcode_list: number;
	member_count: number;
}[]>;
export function searchMemberCount(
	token: string,
	list: number,
	value: string
): SearchMemberCountAction {
	return {
		type: SEARCH_MEMBER_COUNT,
		promise: SearchMembersCount(token, list, value.toLowerCase())
	};
}

export const ADD_SELECTED_MEMBER = "ADD_SELECTED_MEMBER";
type AddSelectedMemberAction = DispatchedAction<typeof ADD_SELECTED_MEMBER, MergedAudienceMember>;
export function addSelectedMember(member: MergedAudienceMember): AddSelectedMemberAction {
	return {
		type: ADD_SELECTED_MEMBER,
		payload: member
	};
}

export const REMOVE_SELECTED_MEMBER = "REMOVE_SELECTED_MEMBER";
type RemoveSelectedMemberAction = DispatchedAction<typeof REMOVE_SELECTED_MEMBER, MergedAudienceMember>;
export function removeSelectedMember(member: MergedAudienceMember): RemoveSelectedMemberAction {
	return {
		type: REMOVE_SELECTED_MEMBER,
		payload: member
	};
}

export const REMOVE_ALL_SELECTED_MEMBERS = "REMOVE_ALL_SELECTED_MEMBERS";
type RemoveAllSelectedMembersAction = DispatchedAction<typeof REMOVE_ALL_SELECTED_MEMBERS, null>;
export function removeAllSelectedMembers(): RemoveAllSelectedMembersAction {
	return {
		type: REMOVE_ALL_SELECTED_MEMBERS,
		payload: null,
	};
}

export const REMOVE_ALL_MEMBERS = "REMOVE_ALL_MEMBERS";
type RemoveAllMembersAction = DispatchedAction<typeof REMOVE_ALL_MEMBERS, null>;
export function removeAllMembers(): RemoveAllMembersAction {
	return {
		type: REMOVE_ALL_MEMBERS,
		payload: null,
	};
}

export const GET_AUDIENCE_INVITE_STATUS = "GET_AUDIENCE_INVITE_STATUS";
type GetAudienceInviteStatusAction = DispatchedAsyncAction<typeof GET_AUDIENCE_INVITE_STATUS, {
	invites: SentScheduledEmailsWithEventName[];
	eventsWithoutInvites: BrandliveEvent[];
	unsubscribedUsers: EmailSubscriptions[];
	pendingInvites: (IScheduledEmail & {
		event_name: string;
	})[];
}>;
export function getAudienceInviteStatus(token: string, channel: number, passcodeList: number, emails: string[]): GetAudienceInviteStatusAction {
	return {
		type: GET_AUDIENCE_INVITE_STATUS,
		promise: GetAudienceInviteStatus(token, channel, passcodeList, emails)
	};
}

export type PasscodeListMemberActions =
	| GetPasscodeListMembersAction
	| SearchMembersAction
	| SearchMemberCountAction
	| AddSelectedMemberAction
	| RemoveSelectedMemberAction
	| RemoveAllSelectedMembersAction
	| RemoveAllMembersAction
	| GetAudienceInviteStatusAction;
